export default function OurStory() {
  return (
    <section className="py-12 md:py-24 px-4 md:px-8 bg-white overflow-x-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:grid md:grid-cols-2 gap-8 md:gap-12 items-center">
          {/* Image first on mobile */}
          <div className="w-full h-56 sm:h-72 md:h-96 rounded-lg overflow-hidden order-first md:order-last">
            <img
              src="https://static.readdy.ai/image/783dd8c3d2d1f38f9648f46144ac17f1/ceda914cc3b0b0adca6e62856214e39b.png"
              alt="Best Building Supplies warehouse"
              className="w-full h-full object-cover object-top"
            />
          </div>
          {/* Text */}
          <div className="w-full order-last md:order-first">
            <h2
              className="text-2xl md:text-4xl font-bold mb-5"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              Our Story
            </h2>
            <div className="space-y-4 text-gray-700 text-sm md:text-base">
              <p>
                Best Building Supplies was founded in 2018 with one clear goal: give South African tradespeople and homeowners access to professional-grade building materials at honest prices.
              </p>
              <p>
                What started as a small depot in Johannesburg producing bricks has grown over 26 years into a whole new production plant bringing more qaulity building materials at fair price. Today our products are sold through 500+ stockists nationwide and have been used on everything from bathroom renovations to large commercial projects.
              </p>
              <p>
                We specialise in four core product categories: Tile Adhesive, Grout, Paint &amp; Coatings, and Bonding Liquid. Each available across our three performance tiers: Everyday for straightforward DIY work, Contractor Grade for professional tradespeople, and Elite Pro Series for demanding commercial applications.
              </p>
              <p className="font-semibold text-gray-900">
                South Africa's buildings deserve the best. That's not just our name it's our promise.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}